/**
 * Skeleton — FROZEN PUBLIC CONTRACT
 *
 * @public API (do not change without coordinating agent sign-off):
 *   @Input() rows: number          (default 5 — number of skeleton row placeholders)
 *   @Input() rowHeight: string     (default 'h-10' — Tailwind height class per row)
 *
 * Usage:
 *   <app-skeleton [rows]="10" />
 *   <app-skeleton [rows]="3" rowHeight="h-16" />
 *
 * Uses .pulse-soft animation (defined in styles.css) — more subtle than animate-pulse.
 */
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-skeleton',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="space-y-3" aria-busy="true" aria-label="Loading content">
      @for (row of rowArray(); track $index) {
        <div
          [class]="'pulse-soft rounded-md ' + rowHeight()"
          style="background-color: rgb(var(--ds-surface-overlay, 231 229 228))"
        ></div>
      }
    </div>
  `,
})
export class SkeletonComponent {
  readonly rows = input<number>(5);
  readonly rowHeight = input<string>('h-10');

  readonly rowArray = computed(() => Array.from({ length: this.rows() }));
}
